<template>
    <label :class="{ 'dark:text-white': !ignoreDarkMode }" class="block font-medium text-sm text-gray-700 transition duration-500 ease-in-out">
        <span v-if="value">{{ value }}</span>
        <span v-else>
            <slot></slot>
        </span>
    </label>
</template>
<script>
export default {
    props: {
        ignoreDarkMode: Boolean,
        value: String,
    }
}

</script>
